export default {
    data() {
        return {
            pageRefreshCallback: null
        }
    },
    computed: {
        marketWindowCurrentTime() {
            return this.$store.state.livePrices.marketWindowCurrentTime;
        }
    },
    watch: {
        marketWindowCurrentTime(newVal, oldVal) {
            if (oldVal && newVal !== oldVal && this.pageRefreshCallback) {
                this.pageRefreshCallback();
            }
        }
    },
    methods: {
        startPageRefresh(callback) {
            this.pageRefreshCallback = callback;
        },
        stopPageRefresh() {
            this.pageRefreshCallback = null;
        }
    },
    beforeDestroy() {
        this.stopPageRefresh();
    }
}
